import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Developers from "./pages/Developers";
import HireDevelopers from "./pages/HireDevelopers";
import DeveloperDashboard from "./pages/developer/DeveloperDashboard";
import CodingTests from "./pages/developer/CodingTests";
import DeveloperApplications from "./pages/developer/DeveloperApplications";
import DeveloperJobSearch from "./pages/developer/DeveloperJobSearch";
import DeveloperProfile from "./pages/developer/DeveloperProfile";
import CompanyDashboard from "./pages/company/CompanyDashboard";
import Admin from "./pages/Admin";
import ChangePassword from "./pages/ChangePassword";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Toaster />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/developers" element={<Developers />} />
            <Route path="/hire-developers" element={<HireDevelopers />} />
            <Route path="/admin" element={<Admin />} />
            <Route
              path="/company-dashboard"
              element={
                <ProtectedRoute>
                  <CompanyDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/developer-dashboard"
              element={
                <ProtectedRoute>
                  <DeveloperDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/developer/coding-tests"
              element={
                <ProtectedRoute>
                  <CodingTests />
                </ProtectedRoute>
              }
            />
            <Route
              path="/developer/applications"
              element={
                <ProtectedRoute>
                  <DeveloperApplications />
                </ProtectedRoute>
              }
            />
            <Route
              path="/developer/job-search"
              element={
                <ProtectedRoute>
                  <DeveloperJobSearch />
                </ProtectedRoute>
              }
            />
            <Route
              path="/developer/profile"
              element={
                <ProtectedRoute>
                  <DeveloperProfile />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>
  );
}

export default App;